import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import { EERIE, CALYPSO } from 'HubStyleTokens/colors';
import Raven from 'raven-js';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIBadge from 'UIComponents/badge/UIBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTypeText = type => {
  switch (type) {
    case 'MEETINGS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.meetings"
      });
    case 'KNOWLEDGE_ARTICLE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.knowledgeArticle"
      });
    case 'PAYMENT_LINK':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.paymentLink"
      });
    case 'INVOICES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.invoices"
      });
    case 'VIDEO_INSERTION':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.video"
      });
    case 'SNIPPETS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.snippets"
      });
    case 'TEMPLATES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.templates"
      });
    case 'DOCUMENTS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.documents"
      });
    case 'QUOTES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.quotes"
      });
    case 'SIGNATURE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.signature"
      });
    default:
      Raven.captureMessage('NO_TYPE_TEXT');
      return '';
  }
};
const getTypeIcon = type => {
  switch (type) {
    case 'MEETINGS':
      return 'meetings';
    case 'KNOWLEDGE_ARTICLE':
      return 'lesson';
    case 'PAYMENT_LINK':
      return 'paymentSubscriptions';
    case 'INVOICES':
      return 'invoice';
    case 'VIDEO_INSERTION':
      return 'insertVideo';
    case 'SNIPPETS':
      return 'textSnippet';
    case 'TEMPLATES':
      return 'salesTemplates';
    case 'DOCUMENTS':
      return 'documents';
    case 'QUOTES':
      return 'lesson';
    case 'SIGNATURE':
      return 'signature';
    default:
      Raven.captureMessage('NO_TYPE_ICON');
      return 'lesson';
  }
};
const getDisabledText = (editorConfig, type) => {
  switch (type) {
    case 'MEETINGS':
      return undefined;
    case 'KNOWLEDGE_ARTICLE':
      return undefined;
    case 'PAYMENT_LINK':
      return undefined;
    case 'INVOICES':
      return undefined;
    case 'VIDEO_INSERTION':
      return undefined;
    case 'SNIPPETS':
    case 'SIGNATURE':
      return undefined;
    case 'TEMPLATES':
      return !editorConfig[type].contactEmail ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.disabledTooltipMessage"
      }) : undefined;
    case 'DOCUMENTS':
      return !editorConfig[type].contactEmail ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.disabledTooltipMessage"
      }) : undefined;
    case 'QUOTES':
      return !editorConfig[type].contactVid ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.disabledTooltipMessage"
      }) : undefined;
    default:
      Raven.captureMessage('NO_DISABLED_TEXT');
      return undefined;
  }
};
function InsertMenuTypeButton({
  type,
  editorConfig,
  onSelectMediaType
}) {
  const config = editorConfig[type];
  if (!config) {
    return null;
  }
  const disabledText = getDisabledText(editorConfig, type);
  const disabled = Boolean(disabledText);
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !disabled,
    title: disabledText,
    children: /*#__PURE__*/_jsxs(UIButton, {
      className: "p-x-4 display-flex align-center justify-between",
      disabled: disabled,
      onClick: () => onSelectMediaType(type),
      children: [/*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-3",
          name: getTypeIcon(type),
          color: EERIE
        }), getTypeText(type), 'showNewTag' in config && config.showNewTag && /*#__PURE__*/_jsx(UIBadge, {
          className: "m-left-3",
          use: "new",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'hubspot-prosemirror.insertMenu.newTag'
          })
        })]
      }), /*#__PURE__*/_jsx(UIIcon, {
        name: "right",
        color: CALYPSO
      })]
    })
  });
}
export const InsertMenuUpgradeButton = ({
  type,
  upgradeKey
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeKey);
  return /*#__PURE__*/_jsxs(UIButton, {
    className: "p-x-4",
    onClick: openUpgradeModal,
    use: "link",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      className: "m-right-3",
      name: getTypeIcon(type),
      color: EERIE
    }), getTypeText(type), /*#__PURE__*/_jsx(UIIcon, {
      className: "m-left-2",
      color: EERIE,
      name: "locked",
      onClick: openUpgradeModal
    })]
  });
};
export default InsertMenuTypeButton;